import axios from "axios";

const apiURL = "https://dev.silversky3d.com/api-levelup";

export async function getCode(classroomCode) {
  return axios
    .get(apiURL + `/user_data/classroom/${classroomCode}`)
    .then((res) => {
      if (res.data.message === "Data retrieved")
      return res.data.results;

    })
    .catch((err) => {
      return err.response.data.message;
    });
};

export async function resetPass(email, password, newPassword) {
  return axios
    .post(apiURL + `/change-password-admin`, {email, password, newPassword})
    .then((res) => {
      if (res.data.status === 200){
        console.log(res.data);
        return res.data;
      }
    })
    .catch((err) => {
      console.log("err: " + err);
      return err.response.data.message;
    });
};


export async function login(email, password) {
   return axios
    .post(apiURL + "/login", {
      email,
      password,
    })
    .then((res) => {
      if (res.data.user_id) {
         // if user is not admin (role 3) 
        if (res.data.role_id !== 3)
           return console.log("Not admin");
        // if user is admin (role 3)
        let data = {
          id: res.data.user_id,
          role: res.data.role_id,
          email: res.data.email,
          token: res.data.jwt,
          message: res.data.message,
        };
        return data;
      }
    })
    .catch((err) => {
      return err.response.data.message;
    });
};

export function logout() {
  localStorage.removeItem("token");
};

export function setToken(token) {
  const now = new Date();
  const expirationTime = now.getTime() + 30 * 60 * 1000; // 30 min from now  24 * 60 *
  localStorage.setItem('token', JSON.stringify({
    value: token,
    expiresAt: expirationTime
  }));
};

// export function setLocalCode(code) {
//   const now = new Date();
//   const expirationTime = now.getTime() + 60 * 60 * 1000; // 1 hour from now 24 *
//   console.log("expirationTime: " + expirationTime);
//   localStorage.setItem('code', JSON.stringify({
//     value: code,
//     expiresAt: expirationTime
//   }));
// };

export function getCurrentUser() {
  // Retrieve the item from localStorage and check if it has expired
  const token = JSON.parse(localStorage.getItem('token'));
  const now = new Date();
  if (token && token.expiresAt > now.getTime()) {
    // The item has not expired yet, so use its value
    return token.value;
  } else {
    // The item has expired or does not exist, so remove it from localStorage
    localStorage.removeItem('token');
  }
};

